module.exports = __webpack_public_path__ + "img/intermediateStepSelected.9f65fe27.png";